import React from "react"
import Zahlungsbedingung from "../../../models/zahlungsbedingung"
import { eventhandlingForLists } from "../../hooks/EventhandlingForLists"
import { ZahlungsbedingungEinfachEintragView } from "./ZahlungsbedingungEinfachEintragView"
import { useStoreRechnung } from "../../../store"

export const ZahlungsbedingungenEinfachListView: () => React.JSX.Element | null = () => {
    const {
        zahlungsdaten: { zahlungsbedingungen: zahlungsbedingungen },
    } = useStoreRechnung("zahlungsdaten")

    const { add, remove, onChange } = eventhandlingForLists("zahlungsdaten.zahlungsbedingungen", () => new Zahlungsbedingung(true))
    const isAddable = (idx: number) => idx === zahlungsbedingungen?.length - 1
    const isRemovable = () => zahlungsbedingungen?.length > 1

    return (
        <>
            {zahlungsbedingungen &&
                zahlungsbedingungen.map((bedingung, idx) => (
                    <ZahlungsbedingungEinfachEintragView
                        key={idx}
                        zahlungsbedingung={bedingung}
                        onAdd={isAddable(idx) ? add : undefined}
                        onRemove={isRemovable() ? remove(idx) : undefined}
                        onChange={onChange(idx)}
                        idx={idx}
                    />
                ))}
        </>
    )
}
